// src/components/VersionNotes.js
import React from 'react';
import TextBox from './TextBox';
import styled from 'styled-components';
import branches from '../assets/branches.jpg';

// Styled container for version notes
const VersionNotesContainer = styled.div`
  padding: 21px;
  background-image: url(${branches});
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
`;

// Wrapper for the version notes content
const ContentWrapper = styled.div`
  border-radius: 12px;
  padding: 20px;
  max-width: 800px;
  text-align: center;
  display: flex;
  flex-direction: column;
  gap: 20px;
  align-items: center;
  justify-content: center;
  position: relative;
  perspective: 1000px;
`;

const VersionNotes = () => {
  return (
    <VersionNotesContainer>
      <ContentWrapper>
        <TextBox>
            <h2>Version 1.1</h2>
            <p>
                Did all the hard stuff before this. Just added footer and started naming versions.
            </p>
        </TextBox>
        <TextBox>
            <h2>Version 1.2</h2>
            <p>
                Big update. Visually focused on removing the generic scroll function and wrapping all content between header and footer. Also added a new customization: me. Ensured proper DNS via Netlify and adjusted AWS Lambda to properly recognize the new domain. This update is also the start of me recording notes in relation to update releases. Also added these version notes when footer is clicked on. 
            </p>
        </TextBox>
        <TextBox>
            <h2>Version 1.3</h2>
            <p>
                Minimal aesthetic update. Added custom favicon and site title with plans for dynamic title in the future. 
            </p>
        </TextBox>
        <TextBox>
            <h2>Version 1.4</h2>
            <p>
                Updated about me and about the site sections. Deprecated contact page.
            </p>
        </TextBox>
        <TextBox>
            <h2>Version 1.5</h2>
            <p>
                Glass feel to text boxes.
            </p>
        </TextBox>
      </ContentWrapper>
    </VersionNotesContainer>
  );
};

export default VersionNotes;